import React, { Component } from 'react';
import { NewAccountIcon } from '../../Assets/Settings/SettingsIcon';
import TaxIcon from '../../Assets/General/TaxIcon';
import DeliveryIcon from '../../Assets/General/DeliveryMethodIcon';
import WarehouseIcon from '../../Assets/General/WarehouseIcon';
import CurrencyIcon from '../../Assets/General/CurrencyIcon';
import PreferencesIcon from '../../Assets/General/PreferenceIcon';
import Loader from '../../Components/Loader/Loader';
import { Header } from '../../Components/Layout/Layout';
import SettingsCard from '../../Components/Card/SettingsCard';
import SettingsPageIcon from '../../Assets/General/SettingPageIcon';
import AccessDenied from '../../Components/AccessDenied/AccessDenied';
import './Settings.css';
import {
  hasPermissionCustom,
  hasViewPermission,
} from '../../Helpers/CustomPermission';
import { checkError, setDeploymentTime } from '../../Helpers/AuthHelper';
import { restRequest } from '../../Helpers/RequestHelper';
import { PdfIcon } from '../../Assets/General';
import { getObjFromLS } from '../../Helpers';
import { withTranslation } from 'react-i18next';
class Settings extends Component {
  state = {
    loading: true,
    taxcount: 0,
    deliverycount: 0,
    accessDenied: false,
  };

  async fetchData() {
    await this.fetchFilteredData();
  }

  componentDidMount() {
    sessionStorage.removeItem('tab');
    document.title = 'Settings';
    this.fetchDeployment();
    this.fetchData().then(() => this.setState({ loading: false }));
  }

  async fetchDeployment() {
    await restRequest('get', `deploymentTime`)
      .then((res) => {
        setDeploymentTime(res);
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        this.setState({ loading: false });
      });
  }

  fetchFilteredData() {
    this.setState({ loading: true, reportLoading: true });

    return restRequest('get', `accounts/system-settings`)
      .then((res) => {
        this.setState({
          taxcount: res.taxes,
          deliverycount: res.deliveryMethods,
          reportLoading: false,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (error?.response?.data?.status !== 'access_denied') {
          this.setState({
            accessDenied: checkError(error, this.props.handleToast),
          });
        } else {
          this.setState({ accessDenied: true });
        }
      });
  }

  render() {
    let permissions = getObjFromLS('role').permissions;
    let { taxcount, deliverycount, accessDenied, loading } = this.state;
    if (loading) return <Loader />;
    if (accessDenied) {
      return <AccessDenied type="section" />;
    }
    return (
      <div className="settings">
        <Header
          title={`${this.props.t('Settings.settings')} - ${this.props.t(
            'Settings.system'
          )}`}
          Icon={SettingsPageIcon}
        ></Header>
        <div className="float-left w-70 seetings_card_parent">
          <div className="colum_3">
            <SettingsCard
              showCreate={false}
              showView={hasViewPermission('account')}
              icon={<NewAccountIcon />}
              link="/setting/account"
              label={this.props.t('Settings.create_account')}
              subtitle={this.props.t('Settings.create_inventory_account')}
            />
          </div>
          <div className="colum_3">
            <SettingsCard
              showCreate={hasPermissionCustom('tax', 'Create')}
              showView={hasViewPermission('tax')}
              icon={<TaxIcon />}
              link={taxcount > 0 ? '/taxes' : ''}
              title="Taxes"
              label={this.props.t('Settings.taxes')}
              subtitle={
                taxcount > 0
                  ? this.props.t('Settings.tax_subtitle_1')
                  : this.props.t('Settings.tax_subtitle_2')
              }
            />
          </div>
          <div className="colum_3">
            <SettingsCard
              showCreate={hasPermissionCustom('deliverymethod', 'Create')}
              showView={hasViewPermission('deliverymethod')}
              icon={<DeliveryIcon />}
              link={deliverycount > 0 ? '/deliverymethods' : ''}
              title="Delivery Methods"
              label={this.props.t('Settings.delivery_methods')}
              subtitle={
                deliverycount > 0
                  ? this.props.t('Settings.delivery_methods_subtitle_1')
                  : this.props.t('Settings.delivery_methods_subtitle_2')
              }
            />
          </div>
          <div className="colum_3">
            <SettingsCard
              showCreate={hasPermissionCustom('warehouse', 'Create')}
              showView={hasViewPermission('warehouse')}
              icon={<WarehouseIcon />}
              link="/warehouses"
              label={this.props.t('Settings.warehouses')}
              subtitle={this.props.t('Settings.warehouse_subtitle')}
            />
          </div>
          {/* <div className="colum_3">
            <SettingsCard
              showCreate={hasPermissionCustom('account', 'Create')}
              showView={hasViewPermission('account')}
              icon={<NewAccountIcon />}
              link="/accounting/account"
              title="Inventory Account"
              label={this.props.t('Settings.inventory_account')}
              subtitle={this.props.t('Settings.create_inventory_account')}
            />
          </div> */}
          <div className="colum_3">
            <SettingsCard
              showCreate={false}
              showView={hasViewPermission('currency')}
              icon={<CurrencyIcon />}
              link="/currencies"
              title="Currency Settings"
              label={this.props.t('Settings.currency_settings')}
              subtitle={this.props.t('Settings.currency_settings_subtitle')}
            />
          </div>
          <div className="colum_3">
            <SettingsCard
              showCreate={false}
              showView={hasViewPermission('preference')}
              icon={<PreferencesIcon />}
              link="/preference"
              title={'Preferences'}
              label={this.props.t('Settings.preferences')}
              subtitle={this.props.t('Settings.preferences_subtitle')}
            />
          </div>
          <div className="colum_3">
            <SettingsCard
              showCreate={hasPermissionCustom('paymentmode', 'Create')}
              showView={hasViewPermission('paymentmode')}
              icon={<CurrencyIcon />}
              link="/paymentmethods"
              title="Payment Methods"
              label={this.props.t('Settings.payment_methods')}
              subtitle={this.props.t('Settings.payment_methods_subtitle')}
            />
          </div>
          {permissions.superAccess && (
            <div className="colum_3">
              <SettingsCard
                showCreate={false}
                showView={true}
                icon={<PdfIcon />}
                link="/pdf-templates"
                title="PDF Templates"
                label={this.props.t('Settings.pdf_templates')}
                subtitle={this.props.t('Settings.pdf_templates_subtitle')}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Settings);
